import React from 'react';
import { Link } from 'react-router-dom';
import { trackEmailClick } from '../analytics';
import HomeSectionLink from './HomeSectionLink';
import { BOOK_DEMO_LABEL, BOOK_DEMO_PAGE_PATH } from '../lib/bookDemo';
import { trackCta } from '../analytics';
import './Footer.css';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer footer--pomelli">
      <div className="container">
        <div className="footer-pomelli-grid">
          <div className="footer-pomelli-brand">
            <Link to="/" onClick={scrollToTop} className="footer-pomelli-logo-link">
              <img
                src="/branding/pycrust-logo.png"
                alt="Pycrust logo"
                className="footer-pomelli-logo"
              />
            </Link>
            <p className="footer-pomelli-tagline">Run your social media agency. Not chaos.</p>
            <p className="footer-pomelli-description">
              Stop chasing approvals across inboxes. A professional utility for high-volume
              video content.
            </p>
          </div>

          <div className="footer-pomelli-column">
            <h4 className="footer-pomelli-heading">Platform</h4>
            <ul className="footer-pomelli-links">
              <li>
                <HomeSectionLink sectionId="workflow">End-to-end workflow</HomeSectionLink>
              </li>
              <li>
                <HomeSectionLink sectionId="workspaces">Client workspaces</HomeSectionLink>
              </li>
              <li>
                <HomeSectionLink sectionId="platforms">Multi-platform publishing</HomeSectionLink>
              </li>
              <li>
                <HomeSectionLink sectionId="pipeline">Approval pipeline</HomeSectionLink>
              </li>
              <li>
                <HomeSectionLink sectionId="review">Review &amp; feedback</HomeSectionLink>
              </li>
              <li>
                <HomeSectionLink sectionId="team">Team roles</HomeSectionLink>
              </li>
            </ul>
          </div>

          <div className="footer-pomelli-column">
            <h4 className="footer-pomelli-heading">Connect</h4>
            <ul className="footer-pomelli-links">
              <li>
                <HomeSectionLink sectionId="get-started">Get started</HomeSectionLink>
              </li>
              <li>
                <Link
                  to={BOOK_DEMO_PAGE_PATH}
                  onClick={() => trackCta('book_demo', 'footer')}
                >
                  {BOOK_DEMO_LABEL}
                </Link>
              </li>
              <li>
                <a
                  href="mailto:contact@pycrust.io"
                  onClick={() => trackEmailClick('footer')}
                >
                  contact@pycrust.io
                </a>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>

          <div className="footer-pomelli-column">
            <h4 className="footer-pomelli-heading">Resources</h4>
            <ul className="footer-pomelli-links">
              <li>
                <Link to="/features">Features</Link>
              </li>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms-of-service">Terms of Service</Link>
              </li>
              <li>
                <Link to="/refund-policy">Refund Policy</Link>
              </li>
              <li>
                <Link to="/account-deletion">Account Deletion</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-pomelli-bar">
          <p className="footer-pomelli-copyright">
            &copy; {new Date().getFullYear()} pycrust.io. All rights reserved by Cube Solutions LLC.
          </p>
          <p className="footer-pomelli-values">
            Security &middot; Transparency &middot; Efficiency &middot; Accountability
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
